import React, { useContext, useEffect, useRef, useState } from 'react';
import { UserContext } from 'contexts';
import { useApi } from 'hooks';
import { navigate } from 'hookrouter';
import { addGroup } from 'api';
import { isValidMortgageRedirectUrl } from 'validation';
import { Process } from 'common';
import ErrorPage from 'pages/errorPage';

//TODO: make configurable
const defaultRedirectUrl = 'https://homeloanapp.orangecountyscu.org/app/single-sign-on/check-status';

// todo: move to common
const objectToQueryString = (obj) => {
  if (!obj) return '';
  const qs = new URLSearchParams();
  Object.entries(obj).forEach(([key, value]) => (value !== undefined ? qs.append(key, value) : null));
  return qs.toString();
};

const SignInRedirectPage = (props) => {
  const { accessToken, appId, redirectUrl } = props;

  const idDestinationUrlValid = isValidMortgageRedirectUrl(redirectUrl);
  if (!idDestinationUrlValid)
    console.log(`redirectUrl: ${redirectUrl} is invalid. using defaultRedirectUrl instead: ${defaultRedirectUrl}`);

  const destinationUrl = idDestinationUrlValid ? redirectUrl : defaultRedirectUrl;

  if (!accessToken) navigate('/sign-in');

  const formRef = useRef(null);
  const [state] = useContext(UserContext);
  const { queryParams } = state;
  const targetUrl = destinationUrl + '?' + objectToQueryString(queryParams);
  console.log('SignInRedirectPage', queryParams, targetUrl);

  // api
  const [addGroupStatus, callAddGroup] = useApi(addGroup);
  const [displayHelp, setDisplayHelp] = useState();

  // Adds user to group then submits the form on first render
  useEffect(() => {
    const initialize = async () => {
      var response = await callAddGroup(accessToken, appId);
      if (!response) {
        setDisplayHelp(true);
        return;
      }

      formRef.current.submit();
    };

    initialize();
    // eslint-disable-next-line
  }, []);

  const isLoading = () => addGroupStatus.isLoading;

  const error = () => {
    let tempError = false;
    if (addGroupStatus.error) tempError = addGroupStatus.error;
    return tempError;
  };

  return (
    <Process error={error} isLoading={isLoading}>
      {displayHelp ? (
        <ErrorPage />
      ) : (
        <form method="post" action={targetUrl} ref={formRef} style={{ display: 'none' }}>
          <input type="hidden" name="accessToken" value={accessToken} />
          <button type="submit">Redirect</button>
        </form>
      )}
    </Process>
  );
};

export default SignInRedirectPage;
